import {TranslatableResourceType} from 'types';

export type Filter = {
  key: 'locale' | 'resource_type';
  value: string[];
} | null;

export function filtersBuilder(
  localeFilter: Filter | null,
  resourceTypeFilter: Filter | null,
) {
  const filterParts = [];

  if (localeFilter) {
    const localeFilters: string[] = [];

    localeFilter.value.forEach((locale) => {
      localeFilters.push(`${localeFilter.key}:${locale}`);
    });

    filterParts.push(`(${localeFilters.join(' OR ')})`);
  }

  if (resourceTypeFilter) {
    const resourceTypeFilters: string[] = [];

    resourceTypeFilter.value.forEach((resourceType) => {
      resourceTypeFilters.push(`${resourceTypeFilter.key}:${resourceType}`);

      if (resourceType === TranslatableResourceType.Product) {
        resourceTypeFilters.push(
          `${resourceTypeFilter.key}:${TranslatableResourceType.ProductOption}`,
          `${resourceTypeFilter.key}:${TranslatableResourceType.ProductOptionValue}`,
        );
      }

      if (resourceType === TranslatableResourceType.OnlineStoreMenu) {
        resourceTypeFilters.push(
          `${resourceTypeFilter.key}:${TranslatableResourceType.Link}`,
        );
      }
    });

    filterParts.push(`(${resourceTypeFilters.join(' OR ')})`);
  }

  return filterParts.join(' AND ');
}
